import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { unresolvedDisputeSchema } from "@common/components/helpers/validation-schemas/unresolvedDisputeSchema";
import UnresolvedDisputeAction from "@common/redux/actions/UnresolvedDisputeAction";
import LoadingAction from "@common/redux/actions/LoadingAction";
import IncidentClient from "@common/api/IncidentClient";
import { mapToSelect } from "@common/components/helpers/forms";
import { useSelector } from "react-redux";
import LoginAction from "@common/redux/actions/LoginAction";
import useCompliance from "./useCompliance";

export const useUnresolvedDispute = (sigPad) => {
  const { siteGuid, optionDisplaySessionsInCompliance } = useSelector((store) =>
    LoginAction.getStatePath(store),
  );
  const { formData } = useSelector((store) =>
    UnresolvedDisputeAction.getStatePath(store),
  );
  const setState = (data) => UnresolvedDisputeAction.dispatch(data);

  const schema = unresolvedDisputeSchema(false);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: formData,
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  const handleBack = () => {
    if (sigPad.current) sigPad.current.clear();
    resetComplianceForms();
  };

  useEffect(() => {
    LoadingAction.set(true).then(() => {
      IncidentClient.MetaData(siteGuid)
        .then((response) => {
          const { gamblingDisputeTypes } = response;
          const disputeTypes = mapToSelect(gamblingDisputeTypes);
          UnresolvedDisputeAction.dispatch({
            types: disputeTypes,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          LoadingAction.set(false);
        });
    });
  }, [siteGuid]);

  return { methods, setState, handleBack };
};
